import { DesktopAlert } from 'admin/notifications/Notifications.types';

// Toggle: true = mock data (no backend), false = real API
export const USE_MOCK_DATA = false;

const MOCK_ALERT_SETS: DesktopAlert[][] = [
    // Cycle 0: review + listing alerts (shows immediately)
    [
        {
            id: 'mock-review-positive',
            agencyID: 1,
            tenantID: '1173',
            userID: '210414',
            objectIDs: ['rev-001', 'rev-002', 'rev-003', 'rev-004', 'rev-005', 'rev-006'],
            notificationHistoryIDs: ['hist-001', 'hist-002'],
            eventType: 'ReviewResponse',
            createdDate: Date.now() - 60000,
            payload: '6 positive <b>5★</b> reviews added across 3 locations',
            impactAnalysis: "Celebrating these reviews will help boost your brand's visibility and trust.",
        },
        {
            id: 'mock-listing-website',
            agencyID: 1,
            tenantID: '1173',
            userID: '210414',
            objectIDs: ['bl-001', 'bl-002', 'bl-003'],
            notificationHistoryIDs: ['hist-003'],
            eventType: 'BL',
            createdDate: Date.now() - 120000,
            payload: "Website link missing on Reputation's Profile at <b>25 Locations</b>",
            impactAnalysis: 'Missing website links reduce traffic to your site and may affect local search rankings.',
        },
    ],
    // Cycle 1: empty (triggers backoff)
    [],
    // Cycle 2: negative review
    [
        {
            id: 'mock-review-negative',
            agencyID: 1,
            tenantID: '1173',
            userID: '210414',
            objectIDs: ['rev-010'],
            notificationHistoryIDs: ['hist-004'],
            eventType: 'ReviewResponse',
            createdDate: Date.now() - 30000,
            payload: 'New <b>1★</b> Review Received',
            impactAnalysis:
                "This negative review may impact your location's rating. A timely response can help mitigate the effect.",
        },
    ],
    // Cycle 3: empty (triggers backoff)
    [],
    // Cycle 4: volume drop + hours missing
    [
        {
            id: 'mock-review-volume',
            agencyID: 1,
            tenantID: '1173',
            userID: '210414',
            objectIDs: ['rev-020', 'rev-021', 'rev-022', 'rev-023', 'rev-024'],
            notificationHistoryIDs: ['hist-005'],
            eventType: 'ReviewResponse',
            createdDate: Date.now() - 60000,
            payload: 'Review volume is <b>40% lower</b> than last month across 5 Locations',
            impactAnalysis: 'A sustained drop in review volume can signal declining customer engagement.',
        },
        {
            id: 'mock-listing-hours',
            agencyID: 1,
            tenantID: '1173',
            userID: '210414',
            objectIDs: ['bl-010', 'bl-011', 'bl-012', 'bl-013', 'bl-014'],
            notificationHistoryIDs: ['hist-006'],
            eventType: 'BL',
            createdDate: Date.now() - 90000,
            payload: 'Business hours missing across <b>10 locations</b>',
            impactAnalysis:
                'Customers rely on accurate business hours. Missing hours can lead to negative experiences.',
        },
    ],
];

let mockCycleIndex = 0;

export const getMockDesktopAlerts = (): DesktopAlert[] => {
    const alerts = MOCK_ALERT_SETS[mockCycleIndex % MOCK_ALERT_SETS.length];

    mockCycleIndex += 1;

    return alerts;
};

export const resetMockState = (): void => {
    mockCycleIndex = 0;
};
